import BaseRepository from './base-repository';
import { LanguageEntity } from '@/types/Language';

export default class LanguageRepository extends BaseRepository<LanguageEntity> {
   constructor() {
      super('/clfinder/user/language', 'code');
   }

   public change(language: string) {
      return this._put(this._resource, { language });
   }
}
